import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const PriceOverrideContainer = styled.div`
    margin-top: 52px;
    .buttonStyle {
        background: none;
        color: #202124;
        border-radius: 0px;
        font-size: 14px;
        font-family: var(--unnamed-font-style-normal) normal
            var(--unnamed-font-weight-normal) var(--unnamed-font-size-14) /
            var(--unnamed-line-spacing-20)
            var(--unnamed-font-family-avenir-next-world) !important;
        padding: 6px 8px !important;
        text-transform: none !important;
        border-bottom: 2px solid #fff !important;
    }

    .buttonStyleWithBorder {
        color: #202124;
        border-radius: 0px;
        font-size: 14px;
        border-bottom: 2px solid #1010eb !important;
        box-shadow: 0 0 0 0 rgb(211 212 213 / 0%) !important;
        font-weight: bold;
        font-family: var(--unnamed-font-style-normal) normal
            var(--unnamed-font-weight-normal) var(--unnamed-font-size-14) /
            var(--unnamed-line-spacing-20)
            var(--unnamed-font-family-avenir-next-world) !important;
        padding: 6px 8px !important;
        text-transform: none !important;
    }

    .inputSearch {
        padding-left: 16px;
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 2px solid #ebeded;
        border-radius: 4px;
        padding-right: 16px;
        margin-left: 10px;
        font-size: 14px;
    }
    .searchtStyle {
        border-width: 0 !important;
        width: 100% !important;
        outline: 0 !important;
        padding: 6px !important;
    }
    .cardContainer {
        box-shadow: 0px 0px 6px #00000029;
        width: 50%;
        ${media.mobileDevice`
    width:100%;
   `}
        background: #FFFFFF 0% 0% no-repeat padding-box;
        border-radius: 6px;
    }
    .inputStyle,
    .inputStyle:focus,
    .inputStyle:active,
    .inputStyle:focus-visible {
        border-width: 0 !important;
        width: 100% !important;
        outline: 0 !important;
        padding: 6px !important;
    }
    .cardHeader {
        background: #fff;
        border-width: 0;
    }
    .MuiAutocomplete-inputFocused {
        opacity: 1;
        border: 0 !important;
        outline: 0;
        border-width: 0 !important;
        width: 100% !important;
        outline: 0 !important;
        padding: 6px !important;
    }
    .textMuted {
        font-size: 6px !important;
        color: red !important;
    }
    ${media.mobileDevice`
        width:100%;
        margin-top:22px;
        border-radius:12px;
        background-color:#F5F5F5;
    `}
`;

export const Text = styled.div`
    font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};
    color: #3d3d3d;
    font-family: 'AvenirNextWorld Demi';
    opacity: 1;
    text-align: left;
    margin: ${(props) => (props.margin ? props.margin : '0 0 0 4px')};
    ${media.mobileDevice`
   
    `}
`;
export const ResetReasonWrapper = styled.div`
    display: flex;

    flex-direction: row;
    justify-content: space-between;
    ${media.mobileDevice`
    flex-direction: column;
    `}
`;
export const ReasonContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 345px;
    //justify-content: space-between;
    ${media.smalDevice`
    flex-direction: row;
    align-items: center;
    width:100%;
    `}
    ${media.mobileDevice`
    align-items: flex-start;
    flex-direction: column;
    `}
`;

export const StyledTotalPrice = styled.div`
    color: #140f4b;
    font-family: 'AvenirNextWorld Demi';
`;
